import React from 'react';
import { IPavementOrder } from '../../../../../../../../store/ducks/fabrication-mockups/types';
import { EFabricationOrderStatus } from '../../../../../../../../store/ducks/fabrication-orders/types';
import { Container } from './styles';

interface IPavementOrdersProps {
  orders: IPavementOrder[];
}

const PavementOrders: React.FC<IPavementOrdersProps> = ({ orders }) => {
  const getOrdersNumbers = (): {
    billedOrders: number;
    openOrders: number;
    canceledOrders: number;
  } => {
    const getOrdersByStatus = (
      statusList: EFabricationOrderStatus[]
    ): number => {
      return orders.filter((order) =>
        statusList.includes(
          order.orderStatus.toString() as EFabricationOrderStatus
        )
      ).length;
    };

    const billedOrders = getOrdersByStatus([EFabricationOrderStatus.FATURADO]);
    const openOrders = getOrdersByStatus([
      EFabricationOrderStatus.ENVIADO,
      EFabricationOrderStatus.CONFIRMADO,
      EFabricationOrderStatus.EM_PRODUCAO,
      EFabricationOrderStatus.PARCIALMENTE_FATURADO
    ]);
    const canceledOrders = getOrdersByStatus([
      EFabricationOrderStatus.CANCELADO
    ]);
    return { billedOrders, openOrders, canceledOrders };
  };

  const { billedOrders, openOrders, canceledOrders } = getOrdersNumbers();

  const getTextOrders = (numberOfOrders: number): string => {
    if (numberOfOrders === 1) {
      return '1 pedido ';
    } else if (numberOfOrders > 1) {
      return `${numberOfOrders} pedidos `;
    }

    return 'Nenhum pedido ';
  };

  return (
    <>
      <Container>
        <span className="title">Pedidos</span>
        <span className="subtitle">
          {getTextOrders(billedOrders)} "Faturado"
        </span>
        <span className="subtitle">
          {getTextOrders(openOrders)} "Em aberto"
        </span>
        <span className="subtitle">
          {getTextOrders(canceledOrders)} "Cancelado"
        </span>
      </Container>
    </>
  );
};

export default PavementOrders;
